import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable, catchError, switchMap, throwError } from 'rxjs';
import { ApigeeService } from './apigee.service';

@Injectable({
  providedIn: 'root',
})
export class CustomInterceptor implements HttpInterceptor {
  constructor(private readonly apigeeService: ApigeeService) {}

  aux = 0;

  handleError(error: any, request: HttpRequest<any>, next: HttpHandler) {
    if (error.status === 401) {
      return this.apigeeService.tokenApigeeObs().pipe(
        switchMap((resp) => {
          this.apigeeService.token.next(resp.access_token);
          let token = 'Bearer ' + resp.access_token;
          const newReq = request.clone({
            headers: request.headers.set('Authorization', token),
          });
          return next.handle(newReq);
        })
      );
    }
    return throwError(() => error);
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.url.includes('qrvalidator')) {
      let token = 'Bearer ' + this.apigeeService.tokenApigee.getValue();
      const newReq = req.clone({
        headers: req.headers.set('Authorization', token),
      });
      return next.handle(newReq).pipe(
        catchError((error) => {
          return this.handleError(error, newReq, next);
        })
      );
    } else {
      return next.handle(req);
    }
  }
}
